export default `
    id
    name
    alpha2
    alpha3
    num
`
